import {generalRequest} from "@/lib/services/requests";
import {useMutation, useQuery} from "@tanstack/react-query";

export const useApiSearchAdminClassroom = (config) => {
    return useQuery({
        queryKey: ['admin', 'classroom', 'search', config],
        queryFn: () => ((async (config = {}) => {
            return generalRequest.get(`/admin/classrooms`, {params: config})
        })(config)),
    })
}


export const useApiSearchStudentClassroomForMap = (config) => {
    return useQuery({
        queryKey: ['student', 'classroom', 'search', config],
        queryFn: () => ((async (config = {}) => {
            return generalRequest.get(`/student/classrooms/map`, {params: config})
        })(config)),
    })
}


export const useApiReadAdminClassroom = (id) => {
    return useQuery({
        queryKey: ['admin', 'classroom', 'get', id],
        queryFn: () => ((async (id = {}) => {
            return generalRequest.get(`/admin/classrooms/${id}`)
        })(id)),
    })
}
export const useApiReadStudentClassroom = (id) => {
    return useQuery({
        enabled: !!id,
        queryKey: ['student', 'classroom', 'get', id],
        queryFn: () => ((async (id = {}) => {
            return generalRequest.get(`/student/classrooms/${id}`)
        })(id)),
    })
}


export const useApiCreateAdminClassroom = (config) => {
    return useMutation({
        mutationFn: (args) =>
            ((async (data = {}) => {
                return generalRequest.post(`/admin/classrooms`, data)
            })(args))
    });
}


export const useApiUpdateAdminClassroom = (config) => {
    return useMutation({
        mutationFn: (args) =>
            ((async (data = {}) => {
                return generalRequest.put(`/admin/classrooms/${data?.id}`, data)
            })(args))
    });
}


export const useApiDeleteAdminClassroom = (config) => {
    return useMutation({
        mutationFn: (args) =>
            ((async (data = {}) => {
                return generalRequest.delete(`/admin/classrooms/${data?.id}`)
            })(args))
    });
}


